module.exports = __webpack_public_path__ + "img/2-3.0fd59ae0.png";